import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { classNames } from '../../utils';
import { DateTime } from 'luxon';
import ChevronLeft from '../../icons/ChevronLeft';
import ChevronRight from '../../icons/ChevronRight';
import Button from '../Button';
import styles from './MonthPicker.module.css';
const months = [
    'JAN',
    'FEB',
    'MAR',
    'APR',
    'MAY',
    'JUN',
    'JUL',
    'AUG',
    'SEP',
    'OCT',
    'NOV',
    'DEC',
];
const MonthPicker = ({ selectedMonthIndex, setSelectedMonthIndex, selectedYear, setSelectedYear, disableFuture, disableBefore, disableAfter, ianaTimeZoneCode, }) => {
    const now = DateTime.fromJSDate(new Date()).setZone(ianaTimeZoneCode);
    const currentYear = now.year;
    const currentMonthIndex = now.month - 1;
    const isCurrentYearSelected = currentYear === selectedYear;
    const [displayedMonthIdx, setDisplayedMonthIdx] = useState(selectedMonthIndex);
    const before = disableBefore === null || disableBefore === void 0 ? void 0 : disableBefore.split('-');
    const yearJustBefore = Number(before === null || before === void 0 ? void 0 : before[0]);
    const monthJustBefore = Number(before === null || before === void 0 ? void 0 : before[1]);
    const after = disableAfter === null || disableAfter === void 0 ? void 0 : disableAfter.split('-');
    const yearJustAfter = Number(after === null || after === void 0 ? void 0 : after[0]);
    const monthJustAfter = Number(after === null || after === void 0 ? void 0 : after[1]);
    const isYearBefore = useCallback((year) => yearJustBefore > year, [yearJustBefore]);
    const isYearAfter = useCallback((year) => yearJustAfter < year, [yearJustAfter]);
    const isMonthIdxOutOfRange = useCallback((monthIdx) => {
        if (isYearBefore(selectedYear) || isYearAfter(selectedYear))
            return true;
        const month = monthIdx + 1;
        let validity = true;
        if (selectedYear === yearJustBefore && monthJustBefore > month) {
            validity = false;
        }
        if (selectedYear === yearJustAfter && monthJustAfter < month) {
            validity = false;
        }
        return !validity;
    }, [isYearAfter, isYearBefore, monthJustAfter, monthJustBefore, selectedYear]);
    useEffect(() => {
        if (!disableFuture || !isCurrentYearSelected)
            return;
        if (selectedMonthIndex > currentMonthIndex)
            setDisplayedMonthIdx(currentMonthIndex);
        if (selectedYear > currentYear)
            setSelectedYear(currentYear);
    }, [
        isCurrentYearSelected,
        currentMonthIndex,
        selectedMonthIndex,
        setSelectedMonthIndex,
        currentYear,
        selectedYear,
        setSelectedYear,
        disableFuture,
    ]);
    useEffect(() => {
        if (isMonthIdxOutOfRange(displayedMonthIdx)) {
            if (selectedYear === yearJustAfter) {
                setDisplayedMonthIdx(monthJustAfter - 1);
                setSelectedMonthIndex(monthJustAfter - 1);
            }
            else if (selectedYear === yearJustBefore) {
                setDisplayedMonthIdx(monthJustBefore - 1);
                setSelectedMonthIndex(monthJustBefore - 1);
            }
            else {
                setDisplayedMonthIdx(monthJustAfter - 1);
                setSelectedMonthIndex(monthJustAfter - 1);
                setSelectedYear(yearJustAfter);
            }
        }
        else {
            setDisplayedMonthIdx(selectedMonthIndex);
        }
    }, [
        isMonthIdxOutOfRange,
        selectedYear,
        selectedMonthIndex,
        displayedMonthIdx,
        disableBefore,
        disableAfter,
    ]);
    return (_jsxs("div", Object.assign({ className: styles.root }, { children: [_jsxs("div", Object.assign({ className: styles.yearNav }, { children: [_jsx("div", Object.assign({ className: styles.navButtonWrapper }, { children: _jsx(Button, Object.assign({ variant: "text", disabled: isYearBefore(selectedYear - 1), onClick: () => setSelectedYear(selectedYear - 1) }, { children: _jsx("span", Object.assign({ className: styles.navButtonColor }, { children: _jsx(ChevronLeft, { variant: "tiny", size: 20 }, void 0) }), void 0) }), void 0) }), void 0), _jsx("div", { children: selectedYear }, void 0), _jsx("div", Object.assign({ className: styles.navButtonWrapper }, { children: _jsx(Button, Object.assign({ variant: "text", disabled: (isCurrentYearSelected && disableFuture) ||
                                isYearAfter(selectedYear + 1), onClick: () => setSelectedYear(selectedYear + 1) }, { children: _jsx("span", Object.assign({ className: styles.navButtonColor }, { children: _jsx(ChevronRight, { variant: "tiny", size: 20 }, void 0) }), void 0) }), void 0) }), void 0)] }), void 0), _jsx("div", Object.assign({ className: styles.monthSelect }, { children: months.map((monthName, index) => {
                    const isFutureMonth = isCurrentYearSelected && index > currentMonthIndex;
                    const disabled = (disableFuture && isFutureMonth) || isMonthIdxOutOfRange(index);
                    return (_jsx(Button, Object.assign({ variant: "text", className: styles.monthButton, onClick: () => setSelectedMonthIndex(index), disabled: disabled }, { children: _jsx("div", Object.assign({ className: classNames(styles.monthLabel, (disableBefore || disableAfter
                                ? displayedMonthIdx
                                : selectedMonthIndex) === index
                                ? styles.selectedMonth
                                : undefined, disabled ? styles.disabled : undefined) }, { children: monthName }), void 0) }), `monthSelect${index}`));
                }) }), void 0)] }), void 0));
};
export default MonthPicker;
